import controller from './navigation.controller';
import template from './navigation.html';

let navigationComponent = {
    template,
    controller
};

export default navigationComponent;
